import { Claim, ModulesEnum, Role } from '../types';

type ClaimsIds = readonly number[] | null | undefined;
type ModuleIds = readonly number[] | null | undefined;

export const hasCommunityAccess = (claimsIds: ClaimsIds) =>
	Boolean(
		claimsIds?.some(
			claim => claim === Claim.Messenger || claim === Claim.Community,
		),
	);

export const hasCoachingAccess = (claimsIds: ClaimsIds) =>
	Boolean(
		claimsIds?.some(
			claim => claim === Claim.Coaching || claim === Claim.Messenger,
		),
	);

export const hasDealExplorerAccess = (claimsIds: ClaimsIds) =>
	Boolean(claimsIds?.includes(Claim['Deal Explorer']));

export const hasDealFinderGuideAccess = (
	claimsIds: ClaimsIds,
	modulesIds?: ModuleIds,
) =>
	Boolean(
		claimsIds?.some(claim => {
			if (claim === Claim.Vendors) {
				return Boolean(modulesIds?.includes(ModulesEnum.ExpertNetwork));
			}

			return (
				claim === Claim['FMR Explorer'] ||
				claim === Claim['City Research'] ||
				claim === Claim['Property Lookup'] ||
				claim === Claim['Deal Calculator'] ||
				claim === Claim['Deal Explorer']
			);
		}),
	);

/** Guests and trial users: the roles that use the limited guest endpoints. */
export const isLimitedGuestRole = (roleId?: Role | number | null) => {
	const normalizedRoleId = Number(roleId);

	return (
		normalizedRoleId === Role.Guest || normalizedRoleId === Role.TrialUser
	);
};
